<template>
    <FilterComponent :displayText="facet.title" class="boolean-facet">
        <div v-for="option in options" :key="option.value">
            <label class="noselect">
                <input type="checkbox" v-model="selected" :value="option" />
                {{ option.display }}
            </label>
        </div>
    </FilterComponent>
</template>
<script>
import FilterComponent from '../FilterComponent.vue'

export default {
    components: {
        FilterComponent,
    },
    props: {
        facet: {
            type: Object,
            required: true,
        },
        criteria: {
            type: Array,
            default() {
                return []
            },
        },
    },
    computed: {
        options() {
            return this.facet.values.map(v => ({
                ...v,
                name: this.facet.name,
            }))
        },
        selected: {
            get() {
                return this.criteria.filter(c => c.name === this.facet.name)
            },
            set(values) {
                // goals:
                // remove no longer selected criteria
                // append newly selected criteria
                // preserve existing criteria order
                const criteria = this.criteria.filter(c => {
                    // not something we control
                    if (c.name !== this.facet.name) {
                        return true
                    }

                    const found = values.findIndex(v => v.value === c.value)

                    // preserves existing selected criteria
                    if (found > -1) {
                        values.splice(index)
                        return true
                    }

                    // removes no longer selected criteria
                    return false
                })

                // append newly selected criteria
                criteria.push(...values)

                this.$emit('update:criteria', criteria)
            },
        },
    },
}
</script>
<style>
.boolean-facet {
    .control-label.checkbox {
        cursor: pointer;
        text-align: left;

        &.indent {
            position: relative;
            left: 16px;
        }
    }

    label {
        padding: 0px;
        input[type='checkbox'] {
            float: none;
            margin: 0 0 8px;
            padding: 0px;
        }
    }
}
</style>
